export default __webpack_public_path__ + "static/media/2-3_image4.b758cbc0.png";